/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:18 GMT
 */
/* mixins & extensions */
/* helper to properly scale internal durations */
/**
* Currently only used in Checkbox.
*/
:host {
  display: flex;
  cursor: pointer;
  align-self: stretch;
  font-weight: var(--calcite-font-weight-normal);
  transition: background-color var(--calcite-internal-animation-timing-fast) ease-in-out, border-color var(--calcite-animation-timing) ease-in-out;
}

:host label {
  pointer-events: none;
  margin: 0.125rem;
  box-sizing: border-box;
  display: flex;
  flex: 1 1 0%;
  align-items: center;
  color: var(--calcite-color-text-3);
  transition: background-color var(--calcite-internal-animation-timing-fast) ease-in-out, border-color var(--calcite-internal-animation-timing-fast) ease-in-out, color var(--calcite-internal-animation-timing-fast) ease-in-out;
}

.label--horizontal {
  justify-content: center;
}

:host {
  outline-color: transparent;
}

:host(:focus) {
  outline: 2px solid var(--calcite-ui-focus-color, var(--calcite-color-brand));
  outline-offset: calc(
            -2px *
            calc(
              1 -
              2 * clamp(
                0,
                var(--calcite-offset-invert-focus),
                1
              )
            )
          );
  outline-offset: -1px;
}

.label--scale-s {
  padding-inline: 0.5rem;
  font-size: var(--calcite-font-size--2);
  line-height: 1rem;
  padding-block: 0.125rem;
}

.label--scale-m {
  padding-inline: 0.75rem;
  font-size: var(--calcite-font-size--1);
  line-height: 1rem;
  padding-block: 0.375rem;
}

.label--scale-l {
  padding-inline: 1rem;
  padding-block: 0.625rem;
  font-size: var(--calcite-font-size-0);
  line-height: 1.25rem;
}

:host(:hover) label {
  background-color: var(--calcite-color-foreground-2);
  color: var(--calcite-color-text-1);
}

:host(:active) label {
  background-color: var(--calcite-color-foreground-3);
}

:host([checked]) label {
  cursor: default;
  border-color: var(--calcite-color-brand);
  background-color: var(--calcite-color-brand);
  color: var(--calcite-color-text-inverse);
}

:host([checked]) .label--outline,
:host([checked]) .label--outline-fill {
  border-color: var(--calcite-color-brand);
  background-color: var(--calcite-color-foreground-1);
  box-shadow: inset 0 0 0 1px var(--calcite-color-brand);
  color: var(--calcite-color-brand);
}

:host([checked]) .label--outline {
  background-color: transparent;
}

::slotted(input) {
  display: none;
}

@media (forced-colors: active) {
  :host([checked]) label {
    background-color: highlight;
  }
  :host([checked]) .label--outline,
  :host([checked]) .label--outline-fill {
    outline: 2px solid transparent;
    outline-offset: 2px;
  }
  :host([checked]) label:not([class~=label--outline]) .icon {
    color: highlightText;
  }
}
.icon {
  position: relative;
  margin: 0px;
  display: inline-flex;
  line-height: inherit;
  margin-inline-start: var(--calcite-internal-segmented-control-icon-margin-start);
  margin-inline-end: var(--calcite-internal-segmented-control-icon-margin-end);
}

:host([icon-start]) .label--scale-s {
  --calcite-internal-segmented-control-icon-margin-end: 0.5rem;
}

:host([icon-end]) .label--scale-s {
  --calcite-internal-segmented-control-icon-margin-start: 0.5rem;
}

:host([icon-start]) .label--scale-m {
  --calcite-internal-segmented-control-icon-margin-end: 0.75rem;
}

:host([icon-end]) .label--scale-m {
  --calcite-internal-segmented-control-icon-margin-start: 0.75rem;
}

:host([icon-start]) .label--scale-l {
  --calcite-internal-segmented-control-icon-margin-end: 1rem;
}

:host([icon-end]) .label--scale-l {
  --calcite-internal-segmented-control-icon-margin-start: 1rem;
}

.label .icon--solo {
  --calcite-internal-segmented-control-icon-margin-start: 0;
  --calcite-internal-segmented-control-icon-margin-end: 0;
}

:host([hidden]) {
  display: none;
}

[hidden] {
  display: none;
}